import instance, { instanceFile } from "../../ApiConfig";
import { URLS } from "../../ApiConfig/Urls";

const fetchServiceCategory = async () => {
  try {
    console.log("Hello", URLS.GetAdmin + URLS.GetServiceCategory);
    const response = await instance.get(
      URLS.GetAdmin + URLS.GetServiceCategory,
    );

    console.log("Response: ", response);
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle");
  } catch (error) {
    throw error;
  }
};

const fetchServiceCategoryName = async () => {
  try {
    const response = await instance.get(URLS.GetAdmin + URLS.GetCategoryName);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Service Category Value");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const createServiceCategory = async (vehicleData) => {
  try {
    console.log("request is here ", vehicleData);
    const response = await instanceFile.post(
      URLS.GetAdmin + URLS.CreateServiceCategory,
      vehicleData,
    );
    if (response.status === 201) {
      return response.data;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

export default {
  fetchServiceCategory,
  createServiceCategory,
  fetchServiceCategoryName,
};
